import { render, staticRenderFns } from "./Filiacao.vue?vue&type=template&id=5adbb082&scoped=true&"
import script from "./Filiacao.vue?vue&type=script&lang=js&"
export * from "./Filiacao.vue?vue&type=script&lang=js&"
import style0 from "./Filiacao.vue?vue&type=style&index=0&id=5adbb082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adbb082",
  null
  
)

export default component.exports